import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { RentalReviewInsightsDialogComponent } from './rental-review-insights-dialog.component'
import { ChannelRentalAVGRatingItem } from '@tokeet-frontend/reviews'

@Injectable()
export class RentalReviewInsightsDialogService {
  constructor(private dialog: DialogService) {}

  open(data: { rentalId: string; rentalAverageOverallRating: ChannelRentalAVGRatingItem[] }) {
    let defaultConfig: MatDialogConfig = {
      panelClass: 'drawer-full-50',
      data,
    }

    return this.dialog.openDrawer(RentalReviewInsightsDialogComponent, defaultConfig)
  }
}
